import React, { useEffect, useRef, useState } from "react";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";
import { getLineCount } from "@/utils";
import share from "@assets/images/share.png";
import { useDebouncedCallback } from "@/hooks";
import { ShareButtons } from "@components";

const Header = React.memo(function ({
  title,
  className,
  forceLink,
  isShare = true,
}) {
  const url = window.location.href;
  const defaultState = {
    titleClass: "",
    isShowShareButtons: false,
  };
  const [state, setState] = useState(defaultState);
  const ref = useRef(null);
  const navigate = useNavigate();
  const back = () => {
    if (forceLink) {
      navigate(forceLink);
      return;
    }
    navigate(-1);
  };
  const resetState = () => {
    setState({ ...defaultState });
  };
  const handleShare = useDebouncedCallback(() => {
    if (navigator?.canShare?.({ url })) {
      // try {
      //   navigator.share({ url });
      // } catch (err) {
      //   alert(err);
      // }
      setState((s) => ({ ...s, isShowShareButtons: true }));
    } else {
      setState((s) => ({ ...s, isShowShareButtons: true }));
    }
  });
  const onCloseShareModal = () => {
    setState((s) => ({ ...s, isShowShareButtons: false }));
  };

  useEffect(() => {
    const lines = getLineCount(ref.current);
    if (lines > 1) {
      setState((s) => ({ ...s, titleClass: styles.slidingText }));
    }
    return resetState;
  }, []);
  return (
    <div className={className ? `${styles.title} ${className}` : styles.title}>
      <div className={styles.backContainer}>
        <div className={styles.backArea}>
          <div className={styles.backIcon} onClick={back} />
        </div>
      </div>
      <div
        className={styles.titleArea}
        style={isShare ? null : { paddingRight: "40px" }}
      >
        <span ref={ref} className={`${styles.releaseView} ${state.titleClass}`}>
          {title}
        </span>
      </div>
      {isShare && (
        <div className={styles.shareContainer}>
          <img src={share} className={styles.share} onClick={handleShare} />
        </div>
      )}
      {state.isShowShareButtons && (
        <ShareButtons
          url={url}
          title={title}
          open={state.isShowShareButtons}
          onClose={onCloseShareModal}
        />
      )}
    </div>
  );
});

export default Header;
